<template>
  <UIModal
    v-model="visible"
    :header="t('header')"
    :accept-button-label="t('buttons.accept')"
    :cancel-button-label="t('buttons.cancel')"
    @modal-accept="retrySubmit"
  >
    <i18n-t keypath="body" tag="p" />
  </UIModal>
</template>

<script setup lang="ts">
  import { useI18n } from "vue-i18n"
  import { useSessionStore, useFieldStore } from "@versatile-credit-apply/sdk"
  import { computed, onUnmounted, ref } from "vue"
  import {
    useAppFieldModel,
    useOnBeforeSubmit,
  } from "@versatile-credit-apply/components/form"

  const { t } = useI18n()

  const visible = defineModel<boolean>()
  const acceptedNag = ref(false)

  const sessionStore = useSessionStore()
  const fieldStore = useFieldStore()

  const { off, submit } = useOnBeforeSubmit(async () => {
    if (!usePurchaseAmountNag.value) {
      return true
    }

    if (!acceptedNag.value) {
      visible.value = true
    }

    return acceptedNag.value
  })

  const usePurchaseAmountNag = computed(() => {
    const containsPurchaseAmountField = fieldStore.fieldById(
      "purchaseAmountCents"
    )
    if (!containsPurchaseAmountField) {
      return false
    }

    const purchaseAmount = useAppFieldModel("purchaseAmountCents")
    if (purchaseAmount.value) {
      return false
    }
    return sessionStore.properties.purchaseAmountNag
  })

  const retrySubmit = () => {
    visible.value = false
    acceptedNag.value = true
    submit()
  }

  onUnmounted(() => {
    off()
  })
</script>

<i18n lang="yaml" locale="en">
body: >
  Providing an Expected Purchase Amount can help us provide a credit line that better meets your financial needs.

buttons:
  accept: Continue Anyway
  cancel: Cancel

header: >
  Would you like to enter your Expected Purchase Amount?
</i18n>
